export default __webpack_public_path__ + "src/images/packages/villa-mangata/4e37fed76911c5dd5db2a7231c54c7ba-4.jpg";